// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;
}

.login-bg--simple .login-bg__gradient {
  background: radial-gradient(ellipse 90% 60% at 30% 50%, var(--primary-soft) 0%, transparent 55%), radial-gradient(ellipse 70% 50% at 75% 45%, var(--primary-soft) 0%, transparent 55%), linear-gradient(160deg, var(--page-bg) 0%, var(--page-bg-subtle) 100%);
  animation: none;
}

.login-bg--simple .login-bg__grid {
  opacity: 0.5;
}

.login-bg--simple .login-bg__orb,
.login-bg--simple .login-bg__mesh,
.login-bg--simple .login-bg__boxes,
.login-bg--simple .login-bg__nodes {
  display: none;
}

.login-bg__gradient {
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse 80% 50% at 20% 40%, var(--primary-soft) 0%, transparent 50%), radial-gradient(ellipse 60% 40% at 80% 60%, var(--primary-soft) 0%, transparent 50%), linear-gradient(135deg, var(--page-bg) 0%, var(--page-bg-subtle) 100%);
  animation: bgGradientShift 20s ease-in-out infinite;
}

@keyframes bgGradientShift {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.95;
    transform: scale(1.02);
  }
}
.login-bg__orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  opacity: 0.22;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
}

.login-bg__orb--1 {
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(16, 185, 129, 0.5) 0%, transparent 70%);
  top: -10%;
  left: -5%;
  animation: orbFloat1 18s ease-in-out infinite;
}

.login-bg__orb--2 {
  width: 350px;
  height: 350px;
  background: radial-gradient(circle, rgba(52, 211, 153, 0.4) 0%, transparent 70%);
  top: 40%;
  right: -8%;
  animation: orbFloat2 22s ease-in-out infinite;
}

.login-bg__orb--3 {
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, rgba(5, 150, 105, 0.45) 0%, transparent 70%);
  bottom: -5%;
  left: 30%;
  animation: orbFloat3 20s ease-in-out infinite;
}

.login-bg__orb--4 {
  width: 250px;
  height: 250px;
  background: radial-gradient(circle, rgba(16, 185, 129, 0.35) 0%, transparent 70%);
  top: 60%;
  left: 60%;
  animation: orbFloat4 16s ease-in-out infinite;
}

@keyframes orbFloat1 {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  25% {
    transform: translate(30px, 40px) scale(1.05);
  }
  50% {
    transform: translate(-20px, 20px) scale(0.95);
  }
  75% {
    transform: translate(40px, -30px) scale(1.02);
  }
}
@keyframes orbFloat2 {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  33% {
    transform: translate(-50px, -30px) scale(1.08);
  }
  66% {
    transform: translate(-20px, 50px) scale(0.92);
  }
}
@keyframes orbFloat3 {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  50% {
    transform: translate(40px, -40px) scale(1.1);
  }
}
@keyframes orbFloat4 {
  0%, 100% {
    transform: translate(0, 0);
  }
  25% {
    transform: translate(-30px, -20px);
  }
  50% {
    transform: translate(20px, 30px);
  }
  75% {
    transform: translate(-10px, 10px);
  }
}
.login-bg__grid {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0.8;
}

.login-bg__mesh {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
}

.login-bg__boxes {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0.9;
}

.login-bg__nodes {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0.8;
}`, "",{"version":3,"sources":["webpack://./src/pages/auth/login/components/LoginPageBackground.scss"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,gBAAA;EACA,oBAAA;AAAF;;AAIA;EACE,8PACE;EAGF,eAAA;AAJF;;AAOA;EACE,YAAA;AAJF;;AAOA;;;;EAIE,aAAA;AAJF;;AAOA;EACE,kBAAA;EACA,QAAA;EACA,8PACE;EAGF,mDAAA;AAPF;;AAUA;EACE;IAAW,UAAA;IAAY,mBAAA;EALvB;EAMA;IAAM,aAAA;IAAe,sBAAA;EAFrB;AACF;AAKA;EACE,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sCAAA;EACA,mCAAA;AAHF;;AAMA;EACE,YAAA;EACA,aAAA;EACA,gFAAA;EACA,SAAA;EACA,SAAA;EACA,6CAAA;AAHF;;AAMA;EACE,YAAA;EACA,aAAA;EACA,gFAAA;EACA,QAAA;EACA,UAAA;EACA,6CAAA;AAHF;;AAMA;EACE,YAAA;EACA,aAAA;EACA,gFAAA;EACA,WAAA;EACA,SAAA;EACA,6CAAA;AAHF;;AAMA;EACE,YAAA;EACA,aAAA;EACA,iFAAA;EACA,QAAA;EACA,SAAA;EACA,6CAAA;AAHF;;AAMA;EACE;IAAW,mCAAA;EAFX;EAGA;IAAM,4CAAA;EAAN;EACA;IAAM,6CAAA;EAEN;EADA;IAAM,6CAAA;EAIN;AACF;AAFA;EACE;IAAW,mCAAA;EAKX;EAJA;IAAM,8CAAA;EAON;EANA;IAAM,6CAAA;EASN;AACF;AAPA;EACE;IAAW,mCAAA;EAUX;EATA;IAAM,4CAAA;EAYN;AACF;AAVA;EACE;IAAW,0BAAA;EAaX;EAZA;IAAM,kCAAA;EAeN;EAdA;IAAM,gCAAA;EAiBN;EAhBA;IAAM,iCAAA;EAmBN;AACF;AAjBA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAmBF;;AAhBA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAmBF;;AAhBA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAmBF;;AAhBA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAmBF","sourcesContent":["// LoginPageBackground - Professional animated background\n.login-bg {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  overflow: hidden;\n  pointer-events: none;\n}\n\n// Simple variant: no orbs/mesh/boxes, calm gradient + subtle grid\n.login-bg--simple .login-bg__gradient {\n  background:\n    radial-gradient(ellipse 90% 60% at 30% 50%, var(--primary-soft) 0%, transparent 55%),\n    radial-gradient(ellipse 70% 50% at 75% 45%, var(--primary-soft) 0%, transparent 55%),\n    linear-gradient(160deg, var(--page-bg) 0%, var(--page-bg-subtle) 100%);\n  animation: none;\n}\n\n.login-bg--simple .login-bg__grid {\n  opacity: 0.5;\n}\n\n.login-bg--simple .login-bg__orb,\n.login-bg--simple .login-bg__mesh,\n.login-bg--simple .login-bg__boxes,\n.login-bg--simple .login-bg__nodes {\n  display: none;\n}\n\n.login-bg__gradient {\n  position: absolute;\n  inset: 0;\n  background:\n    radial-gradient(ellipse 80% 50% at 20% 40%, var(--primary-soft) 0%, transparent 50%),\n    radial-gradient(ellipse 60% 40% at 80% 60%, var(--primary-soft) 0%, transparent 50%),\n    linear-gradient(135deg, var(--page-bg) 0%, var(--page-bg-subtle) 100%);\n  animation: bgGradientShift 20s ease-in-out infinite;\n}\n\n@keyframes bgGradientShift {\n  0%, 100% { opacity: 1; transform: scale(1); }\n  50% { opacity: 0.95; transform: scale(1.02); }\n}\n\n// Floating gradient orbs — decorative brand glows, safe in both themes\n.login-bg__orb {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(60px);\n  opacity: 0.22;\n  animation-timing-function: ease-in-out;\n  animation-iteration-count: infinite;\n}\n\n.login-bg__orb--1 {\n  width: 400px;\n  height: 400px;\n  background: radial-gradient(circle, rgba(16, 185, 129, 0.5) 0%, transparent 70%);\n  top: -10%;\n  left: -5%;\n  animation: orbFloat1 18s ease-in-out infinite;\n}\n\n.login-bg__orb--2 {\n  width: 350px;\n  height: 350px;\n  background: radial-gradient(circle, rgba(52, 211, 153, 0.4) 0%, transparent 70%);\n  top: 40%;\n  right: -8%;\n  animation: orbFloat2 22s ease-in-out infinite;\n}\n\n.login-bg__orb--3 {\n  width: 300px;\n  height: 300px;\n  background: radial-gradient(circle, rgba(5, 150, 105, 0.45) 0%, transparent 70%);\n  bottom: -5%;\n  left: 30%;\n  animation: orbFloat3 20s ease-in-out infinite;\n}\n\n.login-bg__orb--4 {\n  width: 250px;\n  height: 250px;\n  background: radial-gradient(circle, rgba(16, 185, 129, 0.35) 0%, transparent 70%);\n  top: 60%;\n  left: 60%;\n  animation: orbFloat4 16s ease-in-out infinite;\n}\n\n@keyframes orbFloat1 {\n  0%, 100% { transform: translate(0, 0) scale(1); }\n  25% { transform: translate(30px, 40px) scale(1.05); }\n  50% { transform: translate(-20px, 20px) scale(0.95); }\n  75% { transform: translate(40px, -30px) scale(1.02); }\n}\n\n@keyframes orbFloat2 {\n  0%, 100% { transform: translate(0, 0) scale(1); }\n  33% { transform: translate(-50px, -30px) scale(1.08); }\n  66% { transform: translate(-20px, 50px) scale(0.92); }\n}\n\n@keyframes orbFloat3 {\n  0%, 100% { transform: translate(0, 0) scale(1); }\n  50% { transform: translate(40px, -40px) scale(1.1); }\n}\n\n@keyframes orbFloat4 {\n  0%, 100% { transform: translate(0, 0); }\n  25% { transform: translate(-30px, -20px); }\n  50% { transform: translate(20px, 30px); }\n  75% { transform: translate(-10px, 10px); }\n}\n\n.login-bg__grid {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0.8;\n}\n\n.login-bg__mesh {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0.5;\n}\n\n.login-bg__boxes {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0.9;\n}\n\n.login-bg__nodes {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
